module.exports = __webpack_public_path__ + "img/31.9.TU.9fc578ea.png";